import { render, staticRenderFns } from "./protocol.vue?vue&type=template&id=08c4ecc1&scoped=true&"
import script from "./protocol.vue?vue&type=script&lang=js&"
export * from "./protocol.vue?vue&type=script&lang=js&"
import style0 from "./protocol.vue?vue&type=style&index=0&id=08c4ecc1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c4ecc1",
  null
  
)

export default component.exports